import { FC } from 'react';

import { Box } from '@bonusly/design-system';

interface RemainingTimeProps {
	formattedTime: string;
	totalTime: string;
	timerColor: string;
}

export const RemainingTime: FC<RemainingTimeProps> = ({ formattedTime, totalTime, timerColor }) => {
	return (
		<Box display="flex" flexDirection="row">
			<Box
				px="8px"
				py="2px"
				border="2px"
				bg="rgba(0, 0, 0, 0.3)"
				m={2}
				borderRadius="sm"
				color="white"
				borderColor={timerColor}
				display="flex"
				flexDirection="row"
			>
				<Box width="40px">{formattedTime}</Box> <Box mr={2}>/</Box> <Box>{totalTime}</Box>
			</Box>
		</Box>
	);
};
